import type {
  BashToolInput,
  EditToolInput,
  ExitPlanModeToolInput,
  GlobToolInput,
  GrepToolInput,
  ReadToolInput,
  ToolInput,
  WebFetchToolInput,
  WebSearchToolInput,
  WriteToolInput,
} from './index'

export function isExitPlanModeToolInput(input: ToolInput): input is ExitPlanModeToolInput {
  return 'plan' in input && typeof input.plan === 'string'
}

export function isBashToolInput(input: ToolInput): input is BashToolInput {
  return 'command' in input && typeof input.command === 'string'
}

export function isEditToolInput(input: ToolInput): input is EditToolInput {
  return 'file_path' in input && 'old_string' in input && 'new_string' in input
}

export function isWriteToolInput(input: ToolInput): input is WriteToolInput {
  return 'file_path' in input && 'content' in input && !('old_string' in input)
}

export function isReadToolInput(input: ToolInput): input is ReadToolInput {
  return 'file_path' in input && !('content' in input) && !('old_string' in input)
}

export function isGlobToolInput(input: ToolInput): input is GlobToolInput {
  return 'pattern' in input && !('output_mode' in input)
}

export function isGrepToolInput(input: ToolInput): input is GrepToolInput {
  return 'pattern' in input && ('output_mode' in input || 'glob' in input || 'type' in input)
}

export function isWebFetchToolInput(input: ToolInput): input is WebFetchToolInput {
  return 'url' in input && 'prompt' in input
}

export function isWebSearchToolInput(input: ToolInput): input is WebSearchToolInput {
  return 'query' in input && typeof input.query === 'string'
}
